module.exports = __webpack_public_path__ + "static/img/prev_months.69b8220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo/prev_months.png
// module id = qLaO
// module chunks = 6